import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const PaymentMethodCard = ({ paymentMethod, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [cardNumber, setCardNumber] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [cvv, setCvv] = useState('');
  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdate = () => {
    setIsUpdating(true);
    setTimeout(() => {
      onUpdate({ cardNumber, expiryDate, cvv });
      setIsUpdating(false);
      setIsEditing(false);
      setCardNumber('');
      setExpiryDate('');
      setCvv('');
    }, 1500);
  };

  const getCardIcon = (brand) => {
    const icons = {
      visa: 'CreditCard',
      mastercard: 'CreditCard',
      amex: 'CreditCard',
      discover: 'CreditCard'
    };
    return icons?.[brand] || 'CreditCard';
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-sm overflow-hidden">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-heading font-semibold text-foreground">Payment Method</h3>
          {!isEditing && (
            <Button
              variant="outline"
              size="sm"
              iconName="Edit"
              iconPosition="left"
              onClick={() => setIsEditing(true)}
            >
              Update
            </Button>
          )}
        </div>
      </div>
      <div className="p-6">
        {!isEditing ? (
          <div className="space-y-4">
            <div className="flex items-center space-x-4 p-4 bg-muted/30 rounded-lg">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={getCardIcon(paymentMethod?.brand)} size={24} className="text-primary" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium text-foreground">
                  {paymentMethod?.brand?.charAt(0)?.toUpperCase() + paymentMethod?.brand?.slice(1)} ending in {paymentMethod?.last4}
                </p>
                <p className="text-xs text-muted-foreground">Expires {paymentMethod?.expiry}</p>
              </div>
              <Icon name="CheckCircle" size={20} className="text-success" />
            </div>

            <div className="p-4 bg-success/5 border border-success/20 rounded-lg">
              <div className="flex items-start space-x-3">
                <Icon name="Shield" size={18} className="text-success flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm font-medium text-foreground mb-1">Secure Payment</p>
                  <p className="text-xs text-muted-foreground">
                    Your payment information is encrypted and processed securely through Stripe. We never store your full card details.
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <Input
              label="Card Number"
              type="text"
              placeholder="1234 5678 9012 3456"
              value={cardNumber}
              onChange={(e) => setCardNumber(e?.target?.value)}
              required
            />

            <div className="grid grid-cols-2 gap-4">
              <Input
                label="Expiry Date"
                type="text"
                placeholder="MM/YY"
                value={expiryDate}
                onChange={(e) => setExpiryDate(e?.target?.value)}
                required
              />
              <Input
                label="CVV"
                type="text"
                placeholder="123"
                value={cvv}
                onChange={(e) => setCvv(e?.target?.value)}
                required
              />
            </div>

            <div className="flex items-center space-x-3 pt-4">
              <Button
                variant="default"
                size="default"
                loading={isUpdating}
                onClick={handleUpdate}
              >
                Save Changes
              </Button>
              <Button
                variant="ghost"
                size="default"
                onClick={() => {
                  setIsEditing(false);
                  setCardNumber('');
                  setExpiryDate('');
                  setCvv('');
                }}
                disabled={isUpdating}
              >
                Cancel
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentMethodCard;